import React from 'react'

import SelectParentNew from "../../../../../../gd-ui/select-parent-new/select-parent-new"
import {FieldPickerType} from "../../../../../render/picker"
import {SelectParent_RenderType} from "../../../../../../gd-ui/select-parent-new/@const"

// const debug = "FieldProject_PickerValueEmpty"
const debug = false

export default function FieldProject_PickerValueEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    const onChange = (projectId: ID) => {
        props.onChange?.(projectId || null)
    }

    const renderValueFunc = (projectId: ID | null, showPopover: func) => {
        switch (props.type) {
            case FieldPickerType.CIRCLE:
                return (
                    <div className="ui5-circle-selector not-set" onClick={showPopover}>
                        <div className={Classes("icon", props.field.icon)}/>
                    </div>
                )

            case FieldPickerType.DEFAULT:
            default                     :
                const classes = Classes("ui5-field-picker is-empty", props.className)

                return (
                    <div className={classes} onClick={showPopover}>
                        <div className={Classes("icon", props.field.icon)}/>
                    </div>
                )
        }
    }

    return (
        <SelectParentNew className          = {props.className}
                         projectId          = {null}
                         parentsFor         = {props.field.parentsFor}
                         placeholder        = {props.field.placeholder}
                         unselectLabel      = {props.field.noValueOption ? props.field.noValueOptionLabel : null}
                         renderType         = {SelectParent_RenderType.FUNCTION}
                         renderValueFunc    = {renderValueFunc}
                         hint               = {props.field.label}
                         onChange           = {onChange}/>
    )

    /*return (
        <SelectParent className         = {props.className}
                      renderValue       = "func"
                      renderValueFunc   = {renderValueFunc}
                      parentsFor        = {props.field.parentsFor}
                      viewMode          = {props.field.viewMode}
                      placeholder       = {props.field.placeholder}
                      unselectLabel     = {props.field.noValueOption ? props.field.noValueOptionLabel : null}
                      companies         = {[gd.companyId]}
                      value             = {objectValue} // {value ? {projectId: value} : null}
                      accessLevels      = {props.field.accessLevels}
                      showProjectIcon   = {true}
                      showIcon          = {true}
                      searchable        = {true}
                      hint              = {props.field.label}
                      onChange          = {onChange}/>
    )*/
}
